import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateInventoryItemForm from "../../forms/CreateOrUpdateInventoryItemForm";

interface CreateInventoryItemModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateInventoryItemModal: React.FC<CreateInventoryItemModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Add Inventory Item"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateInventoryItemForm loading={loading} error={error} />
  </AppModal>
);

export default CreateInventoryItemModal;
